// Static data for HomeScreen component
import { CIDashboardData } from "./types";
import { TEXT } from "../../constants/texts";

// Safety topics list - Import from TEXT constants
export const safetyTopics = TEXT.HOME.SAFETY_TOPICS;

// Upcoming events list - Import from TEXT constants
export const upcomingEvents = TEXT.HOME.UPCOMING_EVENTS;

// External links list - Import from TEXT constants
export const externalLinks = TEXT.HOME.EXTERNAL_LINKS;

// Default CI Dashboard data structure
export const defaultCiData: CIDashboardData = {
  counts: {
    total: 0,
    onTrack: 0,
    offTrack: 0,
  },
  columns: TEXT.CI_DASHBOARD.COLUMNS,
  data: [],
};
